<template>
  <transition name="fade">
    <div @click="$emit('on-project-click', project)" :style="`background-image: url('${project.img}');`" class="box">


      <div class="project-info">
        <p class="project-type italic-text">{{ project.type }}</p>
        <p class="project-name">{{ project.name }}</p>
        <p class="project-description">{{ project.description }}</p>

        <a v-if="project.link" :href="project.link" target="_blank" class="project-link link-purple italic-text">Check project</a>
      </div>
      <div class="box-overlay"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ProjectBox",
  props: {
    project: {
      type: Object,
      required: true
    },
  },
  emits: ['on-project-click']
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/base.mixins";
@import "../../../assets/css/base.variables";
@import "../../../assets/css/base.animations";
@import "../../../assets/css/base.fonts";
@import "../../../assets/css/base.vue-transitions.scss";
@import "~@/assets/css/base.links";

.box {
  background-position: center;
  background-size: cover;
  flex: 50%;
  height: 300px;
  overflow: hidden;
  position: relative;
  z-index: 100;

  &:hover {
    cursor: pointer;

    .box-subtitle {
    }

    .box-overlay {
      opacity: 1;
    }

    .project-info {
      top: 40%;

      .project-name {
        color: var(--purple-main);
      }

      .project-description {
        opacity: 1;
      }
    }
  }
}

.project-info {
  @include position-elevation(absolute, $top: 80%, $left: 15px, $elevation: 25);
  transition: 0.3s top ease-in-out;
  //color: white;

  .project-type {
    font-size: 12px;
    margin-bottom: 10px;
  }

  .project-name {
    @extend .font-roboto;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 5px;
    transition: color 0.4s ease-in-out;
  }

  .project-description {
    @extend .font-roboto;
    color: var(--gray-main);
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 15px;
    opacity: 0;
    transition: 0.3s opacity ease-in-out;
  }

  .project-link {
    //color: white;
    color: var(--gray-main);
    font-size: 18px;
  }
}

.box-overlay {
  //@include position(absolute, $top: calc(100% + 50px), $right: 0, $bottom: -50px, $left: 0);
  @include position-elevation(absolute, $top: 0, $right: 0, $bottom: 0, $left: 0, $elevation: 20);
  backdrop-filter: blur(14px);
  opacity: 0;
  transition: 0.3s all ease-in-out;
}

.coming-soon {
  .project-info {
    color: var(--black-text);
  }

  .project-link {
    color: var(--black-text);
  }
}

@media screen and (min-width: $screen-md) {

}

@media screen and (min-width: $screen-lg) {

}
</style>
